
import { useRef, useState } from 'react';
import { Grid, TextField } from '@mui/material';
import { BotonesAndCargando } from '../../components/botones';
import { crearReporteDeInventario, listadoOpsStocks } from '../../../services';
import { AutocompleteConLoading } from '../../components';
import { useInventarioStore } from '../../../stores';
import { useQueryClient } from '@tanstack/react-query';

import Swal from 'sweetalert2';



export const FormularioDescontarStock = ({ handleCerrarModalInv }) => {

    const debounceRef = useRef(null);
    const queryClient = useQueryClient();
    const { activarInventario } = useInventarioStore();

    const [ formInventario, setFormInventario ] = useState({ stock: "", cantidad: "", op: "" });
    const { cantidad, op } = formInventario;
    const [optiones, setOpciones] = useState([]);
    const [cargando, setCargando] = useState(false);


    const handleInputChange = ({ target }) => {
        setFormInventario({
            ...formInventario,
            [target.name]: target.value
        });
    }



    const buscarOp = (texto) => {
        if(debounceRef.current){ clearTimeout(debounceRef.current); }
        debounceRef.current = setTimeout(async () => {
            const query = texto.trim();
            if (query.length === 0) return;

            setCargando(true);
            const respuesta = await listadoOpsStocks(texto);
            setOpciones(respuesta)
            setCargando(false);
        }, 700);
    };


    const handleCrearInventario = async(e) => {
        e.preventDefault();

        if( [cantidad, op].includes('') ) {
            return Swal.fire('Error', 'Todos Los Campos Son Obligatorios', 'error');
        }

        const  { isConfirmed } = await Swal.fire({
            title: 'Sumar stock a op',
            text: `¿Esta seguro de sumar este stock a la op?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Si' 
        });

        if( !isConfirmed ) return;

        const resp = await crearReporteDeInventario({ cantidad, op, stock: activarInventario._id });
        if( resp ){
            queryClient.invalidateQueries({ queryKey: ['todo-inventario'] });
            setFormInventario({ medida: "", nombre: "", cantidad: "" });
            handleCerrarModalInv();
        }
    }


    return (

        <form  onSubmit={ handleCrearInventario }>
            <Grid container spacing={ 2 }>
                <Grid item xs={12}>
                    <AutocompleteConLoading
                        size='small'
                        label="Enviar a op." 
                        placeholder='Enviar a op.' 
                        fullWidth
                        name="op"
                        options={optiones}
                        value={op}
                        loading={cargando}
                        onChange={(newValue) => setFormInventario(item => ({ ...item, op: newValue }))}
                        handleFunction={ (value) => buscarOp(value) }
                    />
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        label="Cantidad"
                        type='number'
                        fullWidth
                        placeholder='Cantidad'
                        name="cantidad"
                        value={ cantidad }
                        onChange={ handleInputChange }
                        size='small'
                    >
                    </TextField>
                </Grid>
            </Grid>

            <Grid container sx={{mb:2, mt:3, display:'flex', justifyContent:'center' }}>
                <Grid item xs={12} sm={6} md={5}>
                    <BotonesAndCargando
                        cargando={cargando}
                        titulo={`Salidad de Stock`}
                        titulo2="Loading..."
                        icon1="save"
                        icon2="save"
                        esSubmit
                    />
                </Grid>
            </Grid>
        </form>

    )
}
